import React from "react";
import { ColorPill, ColorPills } from "web/react/components/color-pills/color-pills";
import { useActiveFilters, useFilter, useFilterSync } from "web/react/hooks/filters";
import { useFilterBack } from "web/react/hooks/filters/use-filter-back";
import { FilterDialogScreen } from "./filter-dialog/filter-dialog-screen";
import styles from "./filters-colors-screen.module.css";

export function FiltersColorsScreen(): JSX.Element | null {
    const { label, options } = useFilter("color");
    const { isActive } = useActiveFilters();
    const { onOptionChange } = useFilterSync();
    const { onFilterBack } = useFilterBack();

    const pills = options.map(
        (color): ColorPill => ({
            id: color.id,
            url: color.url,
            color: color.id.replace("color.", ""),
            label: color.label,
            className: styles.colorPill,
            checked: isActive(color),
            onClick: () => onOptionChange(color),
        })
    );

    return (
        <FilterDialogScreen title={label} onBack={() => onFilterBack("/")}>
            <ColorPills pills={pills} />
        </FilterDialogScreen>
    );
}
